import React, { useState } from 'react';
import NewPranzoCena from '../componets/NewPranzoCena'
import InfoOrder from './InfoOrder';
import '../App.css';

function Consumer(props) {
  const [isOpenInfo, setIsOpenInfo] = useState(true);
  const [cart, setCart] = useState(new Map());



  return (
    <React.Fragment key={1}>
      <InfoOrder
        isOpenInfo={isOpenInfo}
        setIsOpenInfo={setIsOpenInfo}
        cart={cart}
        setCart={setCart}
      />
      <NewPranzoCena cart={cart} setIsOpenInfo={setIsOpenInfo}/>
    </React.Fragment>
  );
}

export default Consumer;
